<template>
	<div class='plots-component'>
		
		<PlotsVbTax/>

		<div class='vb-sheet-block'>
			<span>Доля по запасу бурелома, ветровала: {{ vbPct }}%</span>
		</div>

		<div class='open-btn-block'>
			<button :disabled="!actLpoIsDraft" @click='openModalVbSheet' class='tree-list-btn'>Открыть ведомость</button>
		</div>

		<CustomModal ref='modalVbSheet'>
			<VbSheet/>
		</CustomModal>
	</div>
</template>

<script>
	import { mapState, mapGetters, mapActions } from 'vuex';

	import VbSheet from './Recount__bvSheet';
	import PlotsVbTax from './Recount__plotsBvTax';

	export default {
		name: 'PlotsVb',
		components: {
			VbSheet,
			PlotsVbTax
		},
		data: () => ({
			addMode: false,

			editedPlotNum: -1,
			editedPlot: null,
		}),
		computed: {
			lpo() {
				return this.$store.state.selectedLpo.lpo;
			},

			...mapState('selectedLpo/recount', {
				plotList: state => state['plotList'],
				vbPct: state => state['vbPct'],

			}),

			...mapGetters('selectedLpo/recount', [
				'recountIsOpen'
			]),
			...mapGetters('lpoData', ['actLpoIsDraft'
			])
		},
		methods: {

			openModalVbSheet() {
				this.$refs['modalVbSheet'].open();
			},


			tggleRecount() {
				this.toggleRecount(this.lpo.lpo_id).then(res => {
					this.updatePlotList(this.lpo.lpo_id);
				});
			},

			...mapActions('selectedLpo/recount', [
				'updatePlotList',
				'toggleRecount'
			])
		}
	};
</script>

<!-- <style scoped src='@/style/flex.css'></style> -->
<!-- <style scoped src='@/style/table.css'></style> -->

<style scoped>

	.tree-list-btn {
		margin-right: 10px;
	}

	.title {
		font-size: 1rem;
		font-weight: bold;
		font-style: italic;
		margin-bottom: 10px;
	}

	.open-btn-block{
		margin-top: 10px;
	}

	.toggle-recount-btn {
		margin-top: 20px;
	}

	.vb-sheet-block {
		margin-top: 2.5rem;
	}
</style>